export const selectedAreaSvgStyle = {
	opacity: '0.8',
	fillOpacity: '0.6',
	fill: 'rgba(104, 228, 255, 0.30)',
};

export const areasLayoutId = 'areasLayoutId';
